<template>
  <div>
    <nav class="navbar navbar-default navbar-fixed-top">
      <div class="container-fluid">
        <div class="navbar-header">
          <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <router-link to="/" class="navbar-brand"><img src="https://ballotpedia.org/wiki/skins/BallotpediaBootstrap/images/bp-logo.svg" class="logo"> <span class="subline">Data</span></router-link> 
        </div>
        <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
          <ul class="nav navbar-nav navbar-right">
            <li><a class="logout" v-on:click="logout">Logout</a></li>
          </ul>
        </div>
      </div>
    </nav>
  <div class="container dashboard-container">
    <div class="row">
      <div class="col-xs-12 col-md-6 col-md-offset-3">
        <img src="https://ballotpedia.org/wiki/skins/BallotpediaBootstrap/images/bp-logo.svg" class="logo-small">
        <p class="dashboard-title">Use the buttons below to download your desired format.</p>  
        <div  v-if="fetchQueriesLoading" class="fa-3x loading-icon"> 
          Loading data lists
        <i class="fas fa-spinner fa-spin"></i>
        </div>
        <p v-if="fetchQueriesError">There was a problem fetching the data list.</p>
        <p v-if="limitExceeded" class="limit-error">The download limit has been reached.</p>
      </div>


      <!-- Each Container --> 
      <div class="col-xs-12 col-md-12" v-for="query in queryList" :key="query.index">
        <div class="feed-container">
          <h4>{{ query.title.replaceAll('_', ' ') }}</h4>
          <p>{{ query.description }}</p>
          <p>File last updated: {{query.last_generated}}</p>
          <button v-on:click="fetchData(query.id, 'json')" class="btn btn-default btn" :disabled="loading">JSON</button>
          <button v-on:click="fetchData(query.id, 'csv')" class="btn btn-default btn" :disabled="loading">CSV</button>
          <div  v-if="loading && currentDownload == query.id" class="fa-3x loading-icon"> 
            Generating file...
          <i class="fas fa-spinner fa-spin"></i>
          </div>
          <div>
            <p v-if="downloadError && currentDownload == query.id" class="download-error">There was a problem downloading the data.</p>
          </div>
        </div>
      </div> 


        
      </div>
    </div>
  </div>
</template>


<script>
  export default {
    name: 'Dashboard',
    data: (()=> {
      return {
        loading: false,
        currentDownload: null,
        downloadError: false,
        fetchQueriesLoading: false,
        fetchQueriesError: false,
        queryList: null,
        limitExceeded: false
      }
    }),
    async mounted() {

        // Reset error messages
        this.limitExceeded = false;
        this.fetchQueriesError = false;

        this.fetchQueriesLoading = true;

        let headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
        headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/getQueryList`;

        let response = await fetch(`${process.env.VUE_APP_API4_DOMAIN}/data_clients_users/authorize`, {
          method: "GET",
          headers: headers,
          credentials: 'include'
        })
        
        response = await response.json();
        this.fetchQueriesLoading = false;

        if (response.success) {
          this.queryList = response.data;
        } else {

          if(response.message.includes('Limit Exceeded')) {
            this.limitExceeded = true;
          } else {
            this.fetchQueriesError = true;
          }

        }



    },
    methods: {
      async fetchData(id, format) {

        this.currentDownload = id;
        this.loading = true;


        let payload = {
          id,
          format
        }

        let headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
        headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/getQueryResults`;

        let response = await fetch(`${process.env.VUE_APP_API4_DOMAIN}/data_clients_users/authorize`, {
          method: "POST",
          headers: headers,
          credentials: 'include',
          body: JSON.stringify(payload)
        })
        
        response = await response.json();
        
        this.loading = false;


        if (response.success && response.data.url) {

          // Reset error messages
          this.limitExceeded = false;
          this.downloadError = false;

          // Create temp link to download from S3 URL
          let tempLink = document.createElement('a');
          tempLink.href = response.data.url;
          tempLink.click();

        } else {
          if(response.message.includes('Limit Exceeded')) {
            this.limitExceeded = true;
          } else {
            this.downloadError = true;
          }

        }
   
   
   
      },
      async logout() {
      
        let response = await fetch(`${process.env.VUE_APP_API4_DOMAIN}/data_clients_users/logout`, {
            method: 'POST',
            headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify({})
          })

        response = await response.json();

        if ( response.success ) {
            if ( !'localhost'.includes('localhost') ) {
              document.cookie = "xsrf_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; Domain=.ballotpedia.org;"
            }
            else {
              document.cookie = "xsrf_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;"
            }
          }
    
          this.$router.push({ path: '/' });
      }
    }
  }
</script>


<style scoped>
.dashboard-container{
  margin-top: 100px;
  background: white;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 30px;
  
}

.feed-container {
  /* border: 1px solid #ccc; */
  border-radius: 5px;
  padding: 20px;
  background: #F4F4F4;;
  margin-bottom: 20px;

}

.logo-small {
  width: 150px;
  margin: 0 auto;
  margin-bottom: 10px;
}

.dashboard-title {
  font-size: 18px;
  font-weight: 200;
  padding-bottom: 10px;
}

.feed-container .btn {
  margin-right: 10px;
  width: 100px;
  color: white;
  font-weight: 600;
  background: #334AAB;
  border: none;
}

.logout:hover {
  cursor: pointer;
}

.loading-icon {
  font-size: 20px;
  margin-top: 20px;
}

.download-error {
  padding-top: 10px;
}

.limit-error {
  padding-top: 10px;
  font-size: 20px;
  color: red;
}

</style>
